import { useEffect, useState, useRef, useCallback } from "react";
import { useFrame } from "react-three-fiber";
import useStore from "../store";

export default function useInitAudioVisualizer() {
  const analyserRef = useRef(null);
  const actions = useStore((state) => state.actions);

  function getUserMedia() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      console.log("getUserMedia supported.");
      navigator.mediaDevices
        .getUserMedia({
          audio: true,
        })
        .then(function (stream) {
          console.log(stream);
          const audioCtx = new AudioContext();
          const source = audioCtx.createMediaStreamSource(stream);

          analyserRef.current = audioCtx.createAnalyser();

          analyserRef.current.fftSize = 64;
          source.connect(analyserRef.current);

          requestAnimationFrame(updateAudio);
        })
        .catch(function (err) {
          console.log("The following getUserMedia error occured: " + err);
        });
    } else {
      console.log("getUserMedia not supported on your browser!");
    }
  }

  useEffect(() => {
    getUserMedia();
  }, []);

  function updateAudio() {
    requestAnimationFrame(updateAudio);
    if (analyserRef.current != null) {
      const bufferLength = analyserRef.current.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);
      analyserRef.current.getByteFrequencyData(dataArray);
      actions.setVisualizerArray(dataArray);
    }
  }
}
